import { useMutation } from '@tanstack/vue-query'

const useCreatePackagePaymentLink = () => {
  const authStore = useAuthStore()
  const { sendEventToBackend } = useTracking()
  const { mutateAsync: schedulePaymentCheck } = useSchedulePaymentCheck()
  
  return useMutation({
    mutationFn: async (packageId: string) => {
      const response = await $fetch<{ url: string }>('/api/payment-link', {
        query: {
          email: authStore.user?.email,
          name: `${authStore.user?.firstName} ${authStore.user?.lastName}`,
          id: authStore.user?.id,
          leadId: authStore.user?.leadId,
          packageId,
        },
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      })
      return { response, packageId }
    },
    onSuccess: ({ response, packageId }) => {
      const pkg = response as any
      
      sendEventToBackend('payment_attempt', {
        crm_user_id: authStore.user?.id,
        email: authStore.user?.email,
        phone: authStore.user?.phone,
        fname: authStore.user?.firstName,
        lname: authStore.user?.lastName,
        package_id: packageId,
        currency: 'USD',
        payment_method: 'stripe',
      })

      if (authStore.user?.id && authStore.user?.leadId) {
        schedulePaymentCheck({
          userId: String(authStore.user.id),
          leadId: authStore.user.leadId,
          name: `${authStore.user.firstName} ${authStore.user.lastName}`,
          packageId,
        }).catch((error) => {
          console.error('Failed to schedule payment status check:', error)
        })
      }
      
      navigateTo(response.url, {
        external: true,
      })
    },
  })
}

export default useCreatePackagePaymentLink

